module.exports = "<ul class=\"group-list-container list-group\">\r\n    <list-item ref=\"treeItem\" v-for=\"group in groups\" :group=\"group\" :options=\"options\" :parentGroupCode=\"parentGroupCode\"/>\r\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/views/list/listList.html
// module id = 18
// module chunks = 0